import type { LlmModelDto, LlmProviderKind } from '@paladin-monorepo/common';
import { LlmProviderKind as LlmProviderKindEnum } from '@paladin-monorepo/common';

export type LlmModelPickerOption = LlmModelDto & {
  isCurrentDisabled?: boolean;
};

export function buildPickerModels(
  enabledModels: LlmModelDto[],
  provider: LlmProviderKind,
  currentModel: string | null | undefined,
): LlmModelPickerOption[] {
  const normalizedModel = currentModel?.trim() || null;
  if (!normalizedModel) {
    return enabledModels;
  }

  const exists = enabledModels.some(
    (m) => m.provider === provider && m.id === normalizedModel,
  );
  if (exists) {
    return enabledModels;
  }

  return [
    ...enabledModels,
    {
      id: normalizedModel,
      displayName: normalizedModel,
      provider,
      isCurrentDisabled: true,
    },
  ];
}

export function groupModelsByProvider(
  models: LlmModelPickerOption[],
): Map<LlmProviderKind, LlmModelPickerOption[]> {
  const grouped = new Map<LlmProviderKind, LlmModelPickerOption[]>();
  for (const provider of Object.values(LlmProviderKindEnum)) {
    grouped.set(provider, models.filter((m) => m.provider === provider));
  }
  return grouped;
}
